import { useContext } from "react";
import { MapContext } from "../contexts/MapContext";

const useMapContext = () => {
    return useContext(MapContext);
}

export default useMapContext;